<template>
  <component is="script" type="text/javascript" :src="getResourceUrl(`/js/app_bundle.min.js?v=${today}`)"></component>

    <!-- Import Stripe v3 Script -->
    <component is="script" type="text/javascript" src="https://js.stripe.com/v3/"></component>
      <!-- Google charts -->
  <component is="script" type="text/javascript" src="https://www.gstatic.com/charts/loader.js"></component>
</template>

<script lang="ts" setup>
import { getResourceUrl } from '@/services/admin_actions/apiUtils';

// Update the version number for app_bundle.min.js
const today = new Date().toISOString().split('T')[0].replace(/-/g, '');

// import all the libraries that were used in classic and were fetched from cdns previously
import 'jquery-cropper';
import 'cropperjs';
import 'jquery.cookie';
import 'jquery-ui/ui/widgets/datepicker.js';
import 'tinymce/tinymce.js';
import 'jquery.emojiarea.js';
import CryptoJS from 'crypto-js';
(window as any).CryptoJS = CryptoJS;

//import the jquery ui smoothness and cropper css too
import 'jquery-ui/themes/base/all.css';
import 'cropperjs/dist/cropper.css';

</script>

<style lang="scss"></style>
